/* eslint-disable no-lonely-if */

const initialCampaignUpdatesState = {
  isFetching: false,
  messages: [],
  newMessagesCount: 0,
};

const campaignUpdatesActions = {
  CAMPAIGN_UPDATES_SET_ALL: 'CAMPAIGN_UPDATES_SET_ALL',
};

const campaignUpdatesReducer = (state, action) => {
  const newState = state;
  switch (action.type) {
    case campaignUpdatesActions.CAMPAIGN_UPDATES_SET_ALL:
      if (action.payload.messages) {
        newState.messages = action.payload.messages;
        newState.newMessagesCount = action.payload.newMessagesCount;
      }
      return { ...newState, ...action.payload };
    default:
      return state;
  }
};

export { initialCampaignUpdatesState, campaignUpdatesActions, campaignUpdatesReducer };
